import { render, staticRenderFns } from "./PlayerSystem.vue?vue&type=template&id=49f93c84&scoped=true&"
import script from "./PlayerSystem.vue?vue&type=script&lang=js&"
export * from "./PlayerSystem.vue?vue&type=script&lang=js&"
import style0 from "./PlayerSystem.vue?vue&type=style&index=0&id=49f93c84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f93c84",
  null
  
)

export default component.exports